import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
import png5 from "./5.jpg";
export const shyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录浦发银行APP->顶部搜索【打印交易流水】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      {
        msg: "交易类型【全部】查询时段【近一年】，选择【邮箱发送】填入专属邮箱【提交】",
      },
      { imgs: [png3, png4, png5] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      {
        msg: "交易类型选择【全部】、【交易信息展示】全部勾选，查询时段选择【近一年】",
      },
    ],
  },
];
